export var SLICE_VALUE_ERROR = "Proper value of 'slice' is required!";